import { render, staticRenderFns } from "./AverageTemp.vue?vue&type=template&id=54b3a4d1"
import script from "./AverageTemp.vue?vue&type=script&lang=js"
export * from "./AverageTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports